import React, { useEffect, useState } from "react";
import "./SignIn.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import { RotatingLines } from "react-loader-spinner";
import Logo from "../../../assets/communityXlogo.svg";
import Loginimg from "../../../assets/login.png";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ErrorLabel from "../../../ErrorLabel/ErrorLabel";
import { EmailCheck } from "../../../ConditionChecks/ConditionChecks";
import { LoginUser } from "../../API/User/LoginUser";
import Validate from "../SignUp/Alert";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import Loader from "../../Loader/Loader";
import { ByPassSignInApi } from "../../API/ByPassSignInAPI/ByPassSignInApi";
import { setUserCredentials } from "../../../Utils/LocalStorage";
import blackLogo from "../../../assets/BlackLogo.svg";

const SignIn = ({ status }) => {
  const [signInEmail, setSignInEmail] = useState("");
  const [signInPassword, setSignInPassword] = useState("");
  const [errEmailDisplay, setErrEmailDisplay] = useState("");
  const [errPasswordDisplay, setErrPasswordDisplay] = useState("");
  const [apiErrDisplay, setApiErrDisplay] = useState("");
  const [loading, setLoading] = useState(false);
  // const [oldPassword, setOldPassword] = useState("");
  const [visibleOldPassword, setVisibleOldPassword] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);

  const navigate = useNavigate();

  setTimeout(() => {
    setLoading(false);
  }, 2000);

  window.addEventListener("message", (event) => {
    // if (event.origin === "http://localhost:3000/dashboard") {
    const UserId = event.data.UserId;
    const CityId = event.data.mms_city_id;

    // Process the received data
    // console.log(UserId, "xyz");
    // console.log(CityId, "city");

    if (UserId && CityId) {
      const data = {
        user_id: UserId,
        mms_city_id: CityId,
      };
      setLoading(true);
      LoginByPassApiHandler(data);
    }

    // }
  });

  const LoginByPassApiHandler = async (data) => {
    // setBtnLoading(true);
    const LoginByPassRes = await ByPassSignInApi(data, () => {
      navigate("/");
    });
    if (LoginByPassRes === false) {
      toast.error("Internal Server Error!", {
        position: "top-center",
        width: "auto",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      // setBtnLoading(false);
    } else {
      if (LoginByPassRes.success === true) {
        setUserCredentials(LoginByPassRes);
        setTimeout(() => {
          toast.dismiss();
          toast.clearWaitingQueue();
          toast.success("Successfully logged in", {
            position: "top-center",
            width: "500px",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          navigate("/dashboard");
          setLoading(false);
        }, 1000);
      } else {
        toast.error(LoginByPassRes.mms_status, {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  // const onOldPassword = (e) => {
  //   let oldpswd = e.target.value;
  //   setOldPassword(oldpswd);
  // };

  const OldPasswordVisibleHandler = () => {
    setVisibleOldPassword(true);
  };
  const OldPasswordNotVisibleHandler = () => {
    setVisibleOldPassword(false);
  };

  const onEmail = (event) => {
    let email = event.target.value;
    setSignInEmail(email);
    const EmailValidationOnChange = EmailCheck(email);
    if (EmailValidationOnChange.input === "empty") {
      setErrEmailDisplay("");
    } else if (EmailValidationOnChange.input === "invalid") {
      setErrEmailDisplay(EmailValidationOnChange.err_display);
    } else if (EmailValidationOnChange.validition === true) {
      setErrEmailDisplay("");
    }
    // setErrEmailDisplay("");
    setApiErrDisplay("");
  };

  const onPassword = (e) => {
    setSignInPassword(e.target.value);
    setErrPasswordDisplay("");
    setApiErrDisplay("");
  };

  // const ForgotPasswordHandler = () => {
  //   const EmailValidation = EmailCheck(signInEmail);

  //   if (EmailValidation.validition === true) {
  //     onEmailHolder("");
  //   } else {
  //     onEmailHolder("");
  //   }
  // };

  // function used to navigate to other routes

  const HandleLogin = async (e) => {
    // e.preventDefault();
    const EmailValidation = EmailCheck(signInEmail);
    if (EmailValidation.input === "empty") {
      setErrEmailDisplay(EmailValidation.err_display);
    } else if (EmailValidation.input === "invalid") {
      setErrEmailDisplay(EmailValidation.err_display);
    }
    if (!signInPassword) {
      setErrPasswordDisplay("Password is required!");
    }

    if (signInPassword && signInEmail != "") {
      setBtnLoading(true);
      let LoginCredentials = {
        mms_email: signInEmail,
        mms_password: signInPassword,
      };

      const userLoginData = await LoginUser(LoginCredentials, () => {
        navigate("/");
      });

      if (userLoginData === false) {
        toast.error("Internal Server Error!", {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setBtnLoading(false);
      } else {
        if (userLoginData.success === true) {
          toast.success("Successfully logged in", {
            position: "top-center",
            width: "500px",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setApiErrDisplay(userLoginData.mms_status);
          setSignInEmail("");
          setSignInPassword("");
          navigate("/dashboard");
          setBtnLoading(false);
        } else {
          toast.error(userLoginData.mms_status, {
            position: "top-center",
            width: "500px",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setApiErrDisplay(userLoginData.mms_status);
          setBtnLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    setLoading(true);
  }, []);

  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      HandleLogin();
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col xs lg="6" className="page-content-left hide-mobile">
              <Image src={Loginimg} width="100%" className="mt-5 pt-5"></Image>
              <p className="login-text1 mt-4">Setup your Market Place!</p>
              <p className="login-text2 mt-2 mb-5">
                Log in now and setup your marketplace landing page, add your
                logo, banners, navigation and let the people know about the new
                shopping experience from the locals!{" "}
              </p>
              <p className="login-text1 mt-4">Shop Local Digital is  now CommunityX Digital!</p>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2">
                {status === true ? <Validate /> : <></>}
                {/* {(location.state) ? <Validate/>: <></>} */}

                <Image src={Logo} className="logo_Image"></Image>
                <Image src={blackLogo} className="black_Logo"></Image>
                <h1 className="sign-second mt-4 pt-0">MMS User Login</h1>
              </div>
              <Row>
                <div className="signemail py-3">
                  <div className="formmain signin-row">
                    <Form.Group className="" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        User ID <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        type="email"
                        placeholder="Enter User ID"
                        className="custom-formcontrol"
                        onChange={onEmail}
                        value={signInEmail}
                        onKeyPress={handleKeypress}
                      />
                      <ErrorLabel ErrorDisplay={errEmailDisplay} />
                    </Form.Group>

                    <Form.Group
                      className="passMMS"
                      controlId="formBasicPassword"
                      style={{ position: "relative" }}
                    >
                      <Form.Label className="form-label-custom">
                        Password <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        type={visibleOldPassword === true ? "password" : ""}
                        placeholder="Password"
                        className="custom-formcontrol"
                        onChange={onPassword}
                        value={signInPassword}
                        onKeyPress={handleKeypress}
                      />

                      {visibleOldPassword === true ? (
                        <Button
                          variant="outline-secondary"
                          id="button-addon2"
                          className="edit-mainn px-2"
                          onClick={OldPasswordNotVisibleHandler}
                        >
                          <FaEyeSlash className="eyeIcon" />
                        </Button>
                      ) : (
                        <Button
                          variant="outline-secondary"
                          id="button-addon2"
                          className="edit-mainn px-2"
                          onClick={OldPasswordVisibleHandler}
                        >
                          <FaEye className="eyeIcon" />
                        </Button>
                      )}
                      <ErrorLabel ErrorDisplay={errPasswordDisplay} />

                      <div
                        className="text-right"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p
                          className="forgot-text"
                          onClick={() => navigate("/forgot-password")}
                        >
                          Forgot Password
                        </p>
                      </div>
                    </Form.Group>
                    <div className="text-center">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn"
                        onClick={(e) => HandleLogin(e)}
                        // onClick={notify}
                      >
                        {btnLoading === true ? (
                          <RotatingLines
                            strokeColor="white"
                            width={20}
                            visible={true}
                          />
                        ) : (
                          "Login"
                        )}
                      </Button>
                      <div
                        className={
                          apiErrDisplay === "User successfully logged in"
                            ? "successful pt-3"
                            : "failed pt-3"
                        }
                      >
                        {apiErrDisplay}
                      </div>
                      {/* <br /> */}
                      {/* <Link to="/explore">Explore</Link> */}
                    </div>
                  </div>
                  <div className="link-container">
                    <a
                      href="https://meylah.com/privacy-policy/"
                      target="_blank"
                    >
                      <p className="link-text text-center">Privacy Policy</p>
                    </a>
                    <span style={{ color: "#fff" }}>|</span>
                    <a href="https://meylah.com/termsofuse/" target="_blank">
                      <p className="link-text text-center">
                        Terms & Conditions
                      </p>
                    </a>
                  </div>
                  {/* <p className="dont-acc text-center">
                    Don’t have account?{" "}
                    <Link to="/signup" className="signup-text">
                      Sign Up
                    </Link>
                  </p> */}
                </div>
              </Row>
              {/* <p className="loginwith">
                <span>Or Login with</span>
              </p> */}
              {/* <Row className="p-0 mb-3">
                <Col md="6" className="social-main social-main1">
                  <button className="signin-social px-3">
                    <Image
                      src={Facebook}
                      width="35px"
                      className="social-icons"
                    ></Image>
                  </button>
                </Col>
                <Col md="6" className="social-main">
                  <button className="signin-social px-3">
                    <Image
                      src={Gmail}
                      width="35px"
                      className="social-icons"
                    ></Image>
                  </button>
                </Col>
              </Row> */}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SignIn;
